<motn-subnav
  [items]="subnavItems"
></motn-subnav>

<router-outlet></router-outlet>
